<div class="tw-h-full">
    <app-dashboard-header
        (toggleSidebar)="toggleSidebar()"
        [haveNotifications]="haveUnreadNotifications"
    ></app-dashboard-header>
    <div
        class="tw-flex tw-h-full md:tw-w-[calc(100%-70px)] md:tw-ml-auto xl:tw-m-auto tw-w-full xl:tw-w-full"
    >
        <div class="">
            <app-dashboard-sidebar
                [isOpen]="isOpen"
                [haveNotifications]="haveUnreadNotifications"
                (toggleSidebar)="toggleSidebar()"
            ></app-dashboard-sidebar>
        </div>
        <div class="tw-px-5 tw-py-5 tw-w-full">
            <div class="tw-max-w-[1150px] tw-mx-auto tw-w-full">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>
